import {useEffect, useState} from 'react';

const useWindowSize = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const [vertScrollbarVisible, setVertScrollbarVisible] = useState(
        window.innerWidth > document.documentElement.clientWidth
    );
    const [horizScrollbarVisible, setHorizScrollbarVisible] = useState(
        window.innerHeight > document.documentElement.clientHeight
    );

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
            setVertScrollbarVisible(
                window.innerWidth > document.documentElement.clientWidth
            );
            setHorizScrollbarVisible(
                window.innerHeight > document.documentElement.clientHeight
            );
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        width,
        height,
        vertScrollbarVisible,
        horizScrollbarVisible,
    };
};

export default useWindowSize;
